import React, { useState } from "react";
import PropTypes from "prop-types";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import styled from "@emotion/styled";

export const StyledReadMoreButton = styled("button")({
  border: "none",
  background: "none",
  color: "#6860EE",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
});

const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)({ color: "#6860EE" });
const StyledArrowDropUpIcon = styled(ArrowDropUpIcon)({ color: "#6860EE" });

const ReadMore = ({
  children,
  maxCharacterCount = 600,
  maxItems = 5,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (Array.isArray(children)) {
    const visibleItems = isExpanded ? children : children.slice(0, maxItems);
    return (
      <div>
        <div>{visibleItems}</div>
        {children.length > maxItems && (
          <StyledReadMoreButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? (
              <>
                Show less
                <StyledArrowDropUpIcon />
              </>
            ) : (
              <>
                Show more
                <StyledArrowDropDownIcon />
              </>
            )}
          </StyledReadMoreButton>
        )}
      </div>
    );
  }

  if (typeof children === "string") {
    if (children.length <= maxCharacterCount) return <span>{children}</span>;

    return (
      <div>
        <span>
          {isExpanded ? children : `${children.substring(0, maxCharacterCount)}...`}
        </span>
        <StyledReadMoreButton onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? (
            <>
              Read less
              <StyledArrowDropUpIcon />
            </>
          ) : (
            <>
              Read more
              <StyledArrowDropDownIcon />
            </>
          )}
        </StyledReadMoreButton>
      </div>
    );
  }

  return <div>{children}</div>;
};

ReadMore.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  maxCharacterCount: PropTypes.number,
  maxItems: PropTypes.number,
};

export default ReadMore;
